import axios from '@/utils/axiosInt.js'
let card = { //办卡量
    timeChange: function () {
        return axios.get('/bi-api/auth?time=' + new Date() * 1)
    },
    mapDate: function (option) {
        return axios.post('/bi-api/cardStatistics/mapData?time=' + new Date() * 1, option)
    },
    provinceDate: function (option) {
        return axios.post('/bi-api/cardStatistics/provinceData?time=' + new Date() * 1, option)
    },
    cityDate: function (option) {
        return axios.post('/bi-api/cardStatistics/cityData?time=' + new Date() * 1, option)
    },
    siteDate: function (option) {
        return axios.post('/bi-api/cardStatistics/getSiteDataByCityCode?time=' + new Date() * 1, option)
    },
    searchSiteDate: function (option) {
        return axios.post('/bi-api/cardStatistics/getSiteDatas?time=' + new Date() * 1, option)
    },
    vagueSiteDate: function (option) {
        return axios.post('/bi-api/cardStatistics/getSiteData?time=' + new Date() * 1, option)
    },
    //一车多卡
    cardCountList:function(option){
        return axios.post('/bi-api/vehicleCardCount/cardCountList?time=' + new Date() * 1, option)
    },
    //一车多卡详情
    cardDetailList:function(option){
        return axios.post('/bi-api/vehicleCardCount/cardDetailList?time=' + new Date() * 1, option)
    },
    //综合运营数据
    operatorSiteCount:function(option){
        return axios.post('/bi-api/operatorSiteCount/list?time=' + new Date() * 1, option)
    },

    
    exportDataCount: function ({
        start,
        end,
        reqId
    }) {
        return `/bi-api/export/countryData?start=${start}&end=${end}&reqId=${reqId}`
    },
    exportDataCity: function ({
        start,
        end,
        provinceCode,
        reqId
    }) {
        return `/bi-api/export/cityData?start=${start}&end=${end}&provinceCode=${provinceCode}&reqId=${reqId}`
    },
    exportDataSite: function ({
        start,
        end,
        cityCode,
        reqId
    }) {
        return `/bi-api/export/getSiteDatas?start=${start}&end=${end}&cityCode=${cityCode}&reqId=${reqId}`
    },
    progress: function ({
        reqId
    }) {
        return axios.get(`/bi-api/export/getProgress?reqId=${reqId}&_=${new Date()*1}`)
    }
};
let user = { //用户量
    timeChange: function () {
        return axios.get('/bi-api/auth?t='+new Date()*1)
    },
    mapDate: function (option) {
        return axios.post('/bi-api/userInfo/mapData', option)
    },
    provinceDate: function (option) {
        return axios.post('/bi-api/userInfo/provinceData', option)
    },
    cityDate: function (option) {
        return axios.post('/bi-api/userInfo/cityData', option)
    },
    siteDate: function (option) {
        return axios.post('/bi-api/userInfo/sityData', option)
    },
    searchSiteDate: function (option) {
        return axios.post('/bi-api/cardStatistics/getSiteDatas', option)
    },
    vagueSiteDate: function (option) {
        return axios.post('/bi-api/userInfo/getSiteData', option)
    },
    exportDataCount: function ({
        start,
        end,
        reqId
    }) {
        return `/bi-api/export/UcountryData?start=${start}&end=${end}&reqId=${reqId}`
    },
    exportDataCity: function ({
        start,
        end,
        provinceCode,
        reqId
    }) {
        return `/bi-api/export/UcityData?start=${start}&end=${end}&provinceCode=${provinceCode}&reqId=${reqId}`
    },
    exportDataSite: function ({
        start,
        end,
        cityCode,
        reqId
    }) {
        return `/bi-api/export/getUSiteDatas?start=${start}&end=${end}&cityCode=${cityCode}&reqId=${reqId}`
    },
    progress: function ({
        reqId
    }) {
        return axios.get(`/bi-api/export/getProgress?reqId=${reqId}&_=${new Date()*1}`)
    }
}
export default [card, user]